import { gql } from "@apollo/client";

export const CREATE_VIRTUAL_ACCOUNT_DOWNLOAD_TASK = gql`
    mutation CreateVirtualAccountDownloadTask($filters: VirtualAccountFilterTypeInput) {
        createVirtualAccountDownloadTask(filters: $filters)
    }
`;

export interface VirtualAccountDownloadTaskResponse {
    createVirtualAccountDownloadTask: string;
}
